import { memo, useContext } from "react";
import type { MembershipStatus } from "@/api/nurses";
import {
  MonthlyMembershipContext,
  useMonthlyMembership,
  type MonthlyMembershipProviderProps,
} from "@/components/feature/nurse-membership/monthlyMembershipStore";

const MEMBERSHIP_BADGE_LABEL: Record<MembershipStatus, string> = {
  active: "",
  inbound: "전입",
  outbound: "전출",
  dispatch_out: "파견",
  leave: "휴직",
  resigned: "퇴사",
};

export function MonthlyMembershipProvider({
  memberStatusMap,
  selectedGroupId,
  children,
}: MonthlyMembershipProviderProps) {
  return (
    <MonthlyMembershipContext.Provider
      value={{ memberStatusMap, selectedGroupId }}
    >
      {children}
    </MonthlyMembershipContext.Provider>
  );
}

export const MonthlyMembershipBadge = memo(function MonthlyMembershipBadge({
  nurseId,
}: {
  nurseId: string;
}) {
  const { selectedGroupId } = useContext(MonthlyMembershipContext);
  const membership = useMonthlyMembership(nurseId);

  if (
    !membership ||
    (membership.membership_status === "active" && !membership.badge)
  ) {
    return null;
  }

  return (
    <span
      className="ml-1 inline-flex items-center rounded px-1.5 py-0.5 text-[10px] font-semibold bg-gray-100 text-gray-600 align-middle whitespace-nowrap"
      title={`${selectedGroupId ?? ""} 선택 월 소속 상태`}
    >
      {membership.marker ?? ""}
      {membership.badge ?? MEMBERSHIP_BADGE_LABEL[membership.membership_status]}
    </span>
  );
});
